import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CheckoutStore } from '@seatix/checkout-data-access';
import { orderDisplay } from '@seatix/checkout-ui';
import {
  SessionExpirationDialogComponent,
  SessionExpirationDialogData,
} from '@seatix/shared-ui-session-expiration-dialog';
import { AlertService } from '@seatix/shared-util-alert';
import { SharedUiCountdownComponent } from '@seatix/shared/ui/ui-countdown';

@Component({
  selector: 'stx-checkout-countdown',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedUiCountdownComponent],
  host: {
    class: 'inline-flex items-center text-xs gap-2',
  },
  template: `
    <span>Asientos reservados por:</span
    ><stx-ui-countdown
      [duration]="duration()"
      (finished)="onCountdownFinished()"
      (warning)="onCountdownWarning()"
    />
  `,
})
export class CheckoutCountdownComponent {
  #store = inject(CheckoutStore);
  readonly timeRemaining = this.#store.timeRemaining;
  readonly timeElapsed = this.#store.timeElapsed;
  protected readonly duration = computed(() => {
    return this.timeRemaining() - this.timeElapsed();
  });
  #alert = inject(AlertService);
  #dialog = inject(MatDialog);

  onCountdownFinished() {
    if (this.#store.pendingExternalRedirect()) {
      return;
    }

    if (!this.#store.orderLoading()) {
      const order = this.#store.order();
      if (order) {
        const display = orderDisplay(order);
        const dialogData: SessionExpirationDialogData = {
          target: {
            name: display.title || null,
            kind: display.kind === 'season' ? 'season' : 'event',
          },
        };
        this.#dialog
          .open(SessionExpirationDialogComponent, {
            data: { ...dialogData },
          })
          .afterClosed()
          .subscribe(() => {
            if (this.#store.pendingExternalRedirect()) {
              return;
            }
            this.#store.handleExpiration();
            this.#store.clearOrder();
          });
      }
    }
  }

  onCountdownWarning() {
    if (this.#store.pendingExternalRedirect()) {
      return;
    }

    this.#alert.showWarning(
      'Tu sesión está a punto de expirar. Por favor, completa tu compra antes de que se acabe el tiempo.',
      {
        duration: 5000,
      },
    );
  }
}
